export default {
  wap: () => import("/webs/layouts/wap.vue").then(m => m.default || m)
}